import React from 'react'

import { Modal } from '@/components/ui'
import { useDashboard } from '@/hooks'

const MakeDefault = ({ onClose }: { onClose: () => void }) => {
  const dashboardContext = useDashboard()
  const [modalOpen, setModalOpen] = React.useState(true)
  const modalRef = React.useRef<HTMLDivElement | null>(null)
  const currentDefault = dashboardContext.configuration.dashboards.find((d) => d.isDefault)

  React.useEffect(() => {
    if (modalRef.current) {
      const dialog = modalRef.current.closest('dialog') as HTMLDialogElement
      if (dialog) {
        if (modalOpen) {
          if (!dialog.open) {
            dialog.showModal()
          }
        } else if (dialog.open) {
          dialog.close()
        }
      }
    }
  }, [modalOpen])

  const confirm = () => {
    dashboardContext.setDefaultDashboard(dashboardContext.currentDashboard.slug)
    setModalOpen(false)
    onClose()
  }
  return (
    <Modal
      // id="default-dashboard-modal"
      title="Make Default"
      onHide={() => {
        setModalOpen(false)
        onClose()
      }}
      show={modalOpen}
      bodyContent={
        <div className="flex flex-col gap-8 mt-4 " ref={modalRef}>
          <div>
            {currentDefault && <p className="mb-4">Current Default: {currentDefault.title}</p>}
            <p>Please confirm you wish to make the current dashboard the new default.</p>
          </div>
          <div className="flex gap-4 justify-end">
            <button
              className="border border-primary text-priamry hover:bg-primary hover:text-white px-4 py-2 rounded cursor-pointer"
              onClick={() => {
                confirm()
              }}
            >
              Make Dashboard Default
            </button>
            <button
              className="border border-gray-700 text-gray-700 hover:bg-gray-200 px-4 py-2 rounded cursor-pointer"
              onClick={() => {
                setModalOpen(false)
                onClose()
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      }
    />
  )
}

export default MakeDefault
